const landingUserReducer = (state = null, action) => {
  switch (action.type) {
    case 'SET_PAGE_USER':
      return action.data
    default:
      return state
  }
}

export default landingUserReducer
